import { createFileRoute } from "@tanstack/react-router";
import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { getRouteIcon } from "@/utils/getRouteIconComponent";

export const Route = createFileRoute("/_authenticated/reports/")({
  component: Reports,
});

function Reports() {
  useBreadcrumb([
    {
      title: "Reports",
      href: "/reports",
      icon: getRouteIcon(MODULE_KEYS_MAP.reports),
    },
  ]);
  return <div>Work in progress</div>;
}
